<template>
  <div>
    <h2 class="page-title-bar">
      <i class="ico ico-alive-time"></i>
      {{ $t("Robot Config List") }}
    </h2>
    <!-- <div class="row mt-4">
            <div class="col-11">
                <div class="searchArea max=40 mt-0" style="width: 75%">
                    <div class="row">
                        <v-text-field :label="$t('Customer')" :placeholder="`${$t('Input The Customer Code')}`"
                            class="form-input mx-3 col" outlined dense hide-details clearable v-model="companyCode"
                            @keyup.native="clickSearch" @click:clear="clearSearch()"></v-text-field>
                        <v-text-field :label="$t('Store')" :placeholder="`${$t('Input The Store Code')}`"
                            class="form-input ml-3 col" outlined dense hide-details clearable v-model="storeCode"
                            @keyup.native="clickSearch" @click:clear="clearSearch()"></v-text-field>
                    </div>
                    <div class="ml-3">
                        <v-btn text class="btn type-search ml-3" @click="clickSearch">{{ $t("Search") }}
                        </v-btn>
                    </div>
                    <div>
                        <v-btn @click="clearSearch" class="btn type-search ml-3" text>{{
                $t("Clear")
            }}</v-btn>
                    </div>
                </div>
            </div>
        </div> -->
    <div class="mt-7">
      <v-data-table v-model="selected" :headers="headers" :items="tableItems" :hide-default-footer="true"
        disable-pagination item-key="amqpHost" :items-per-page="rowPerPage" class="tbl-type01" :single-select="true"
        :show-select="true">
        <!-- NO DATA MESSAGE  -->
        <template slot="no-data">
          <v-alert dense color="#697A8A" class="ma-0" style="line-height: 19px">
            <v-icon class="mr-1" color="#fff">mdi-alert-outline</v-icon>
            {{ $t("No data available") }}</v-alert>
        </template>
      </v-data-table>
    </div>
    <div class="table-options">
      <div>
        <v-btn class="btn ml-2" text @click="openRobotAddConfigDialog">{{ $t("Add") }} </v-btn>
        <v-btn class="btn bg ml-2" text :disabled="selected.length === 0" @click="openConfirmationModal">{{
        $t("Delete") }}
        </v-btn>
      </div>
      <!-- Pagination -->
      <div v-if="tableItems.length > 0">
        <div class="pageInfo">{{ pageInfoText }}</div>
        <div class="pagination2">
          <label class="pageInfo mr-1" style="position:relative !important;">
            Show
          </label>
          <v-select v-model="pageSize" :items="rowPerPageList" :placeholder="$t('Limit')"
            class="form-input pt-0 col rowPerPage" dense persistent-hint outlined hide-details @change="paging(1)">
            <template v-slot:item="{ item }">
              {{ `${item} Rows` }}
            </template>
            <template v-slot:selection="{ item }">
              <span class="selection-v-select"> {{ `${item} Rows` }}</span>
            </template>
          </v-select>

          <div class="">
            <v-text-field v-model="goToPageInput" class="form-input pt-0 col goToPage ml-1" placeholder="Page" outlined
              dense hide-details solo @keyup.enter="goToPage(goToPageInput, paging, totalPages)"
              append-icon="mdi-chevron-right" @keypress="checkIsNumber($event)"
              @click:append="gotToPage(goToPageInput, paging, totalPages)"></v-text-field>
          </div>
          <button @click="goTenPageBackwards(page, paging)" :class="page < 10 ? 'pagination-nav-disabled' : null"
            class="pagination-nav pagination-nav-prev" type="button">
            <img src="@/assets//img/ico-paging-prev.png" alt="이전 10페이지 이동" />
          </button>
          <v-pagination v-model="page" @input="paging" :length="totalPages * 1 || 1" :total-visible="7" color="#2f3b4c"
            style="display: block"></v-pagination>
          <button @click="goTenPageForward(page, paging, totalPages)"
            :class="page + 10 > totalPages ? 'pagination-nav-disabled' : null"
            class="pagination-nav pagination-nav-next" type="button">
            <img src="@/assets//img/ico-paging-next.png" alt="다음 10페이지 이동" />
          </button>
        </div>
      </div>
    </div>
    <!--Confirm Dialog -->
    <v-dialog v-model="dialogConfirm" width="306" persistent>
      <v-card class="popup popup-success add_store_popup" align="center" justify="center">
        <i class="ico-success"><img src="@/assets/img/ico-caution.png" alt="" /></i>
        <div class="msg">
          <h3 class="mb-0">{{ $t("Delete") }}</h3>
        </div>
        <v-row>
          <v-col>
            <span v-text="confirmMessageText" style="font-size: 15px"></span>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-center">
          <v-btn text icon @click="moveTap('Yes')" class="btn">{{
        $t("Yes")
      }}</v-btn>
          <v-btn text icon @click="moveTap('No')" class="btn">{{
        $t("No")
      }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AddRobotConfig v-if="addRobotConfigDialog" :addRobotConfigDialog="addRobotConfigDialog"
      @closeDialog="closeRobotAddConfigDialog" :company="this.$store.state.auth.user.company"
      :storeCode="this.selectedStore" @reloadRobotConfig="reloadRobotConfig" />
  </div>
</template>
<script>
import commons from '@/plugins/commons'
import { mapGetters } from 'vuex'
import EventBus from '@/plugins/eventBus'
import codes from '@/plugins/codes'
import AddRobotConfig from './Modal/AddRobotConfig.vue'
export default {
  components: {
    AddRobotConfig
  },
  data () {
    return {
      page: 0,
      totalPages: 0,
      pageInfoText: null,
      pageSize: '5',
      goToPageInput: null,
      selectedHeaders: [],
      tableItems: [],
      selected: [],
      dialogConfirm: false,
      confirmMessageText: this.$t('Are you sure you want to delete?'),
      addRobotConfigDialog: false
    }
  },
  computed: {
    rowPerPageList () {
      return this.$store.getters['dataStore/GET_ROWLIST']
    },
    headers () {
      return [
        { text: this.$t('CUSTOMER'), value: 'customer', sortable: false },
        { text: this.$t('STORE'), value: 'storeCode', sortable: false },
        {
          text: this.$t('S3HOST'),
          value: 's3Host',
          sortable: false
        },
        { text: this.$t('AMQPHOST'), value: 'amqpHost', sortable: false }
      ]
    },
    ...mapGetters({ store: 'dataStore/GET_SELECTED_STORE' }),
    selectedStore () {
      return this.$store.getters['dataStore/GET_SELECTED_STORE'].code
    }
  },
  watch: {
    store: {
      handler () {
        this.getRobotConfigList(1)
        this.page = 1
      }
    },
    page: {
      handler (page) {
        this.goToPageInput = page
      }
    }
  },
  mounted () {
    EventBus.$emit('enableSelectedStores', false)
    if (!this.store.code) {
      EventBus.$emit('openSelectedStores')
    } else {
      this.getRobotConfigList(1)
    }
  },
  methods: {
    reloadRobotConfig () {
      this.addRobotConfigDialog = false
      this.getRobotConfigList(1)
    },
    openRobotAddConfigDialog () {
      this.addRobotConfigDialog = true
    },
    closeRobotAddConfigDialog () {
      this.addRobotConfigDialog = false
    },
    openConfirmationModal () {
      this.dialogConfirm = true
    },
    moveTap (YesNo) {
      if (YesNo === 'Yes') {
        this.deleteRobotCommonConfig()
        this.dialogConfirm = false
      } else {
        this.dialogConfirm = false
      }
    },
    deleteRobotCommonConfig () {
      const params = { store: this.selectedStore }
      const config = { params }
      params.company = this.$store.state.auth.user.company
      const msg = 'Loading...'
      EventBus.$emit('toggleLoadingModal', msg, true)
      this.$utils
        .callAxios(
          codes.requests.deleteRobotCommonConfig.method,
          codes.requests.deleteRobotCommonConfig.url,
          config
        )
        .then(res => {
          EventBus.$emit('toggleLoadingModal', msg, false)
          const result = res.data
          EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          this.getRobotConfigList(1)
        })
        .catch(error => {
          EventBus.$emit('toggleLoadingModal', msg, false)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
          console.debug(`Failed to delete robot common config. error: ${error}`)
        })
    },
    paging (page = this.page) {
      this.page = Number(page)
      this.goToPageInput = page
      this.getRobotConfigList(this.page)
    },
    gotToPage (goToPageInput, paging, totalPages) {
      if (totalPages < goToPageInput) {
      } else {
        paging(Number(goToPageInput))
      }
    },
    getPageInfoText (headers, tabelItems) {
      return (
        headers['x-number'] * 1 * headers['x-size'] +
        1 +
        ' to ' +
        (headers['x-number'] * 1 * headers['x-size'] + tabelItems.length) +
        ', ' +
        headers['x-totalelements'] * 1 +
        ' in total'
      )
    },
    getRobotConfigList (page) {
      const params = {}
      if (page !== null) params.page = page
      const config = { params: params }
      params.company = this.$store.state.auth.user.company
      params.store = this.selectedStore
      if (this.pageSize > 0) params.size = this.pageSize
      const msg = 'Loading...'
      EventBus.$emit('toggleLoadingModal', msg, true)
      this.$utils
        .callAxios(
          codes.requests.getRobotCommonConfigList.method,
          codes.requests.getRobotCommonConfigList.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('toggleLoadingModal', msg, false)
          }
          if (res.status === 204) {
            EventBus.$emit('toggleLoadingModal', msg, false)
          }
          this.tableItems = []
          if (res.data) {
            res.data.configList.forEach(element => {
              this.tableItems.push({
                customer: element.company,
                storeCode: element.store,
                amqpHost: element.config.amqpHost,
                s3Host: element.config.s3Host
              })
            })
          } else {
            this.tableItems = []
          }
          const headers = res.headers
          if (headers['x-totalelements'] === '0') {
            this.pageInfoText = '0 in total'
            this.page = 1
            this.totalPages = 1
          } else {
            this.pageInfoText = this.getPageInfoText(headers, this.tableItems)
            this.page = headers['x-number'] * 1 + 1
            this.totalPages = headers['x-totalpages'] * 1
          }
          this.selected = []
        })
        .catch(error => {
          EventBus.$emit('toggleLoadingModal', msg, false)
          this.tableItems = []
          const headers = {}
          headers['x-totalelements'] = 0
          this.pageInfoText = commons.getPageInfoText(headers, [])
          this.totalPages = 0
          this.selected = []
          console.debug(`Could not find any robot common config list. error: ${error}`)
        })
    }
  }

}
</script>
<style scoped>
::v-deep .pagination2 .rowPerPage .v-input__slot {
  width: 100px !important;
  min-height: 32px !important;
  margin-top: 1px;
  padding: 0px 1px 0px 7px !important;
}

::v-deep .pagination2 .rowPerPage .v-input__slot .v-select__selections {
  padding: 0 !important;
}

::v-deep .pagination2 .goToPage .v-input__slot {
  width: 70px !important;
  margin-right: 9px !important;
  min-height: 32px !important;
  margin-top: 3px;
  padding: 0px 1px 0px 7px !important;
}

::v-deep .pagination2 .rowPerPage .v-input__slot .v-input__icon {
  align-items: end !important
}

::v-deep .v-data-table__selected.row-class {
  background: #09263f !important;
}

::v-deep.tbl-type01 tbody .v-data-table__selected.row-class td {
  color: #fff !important;
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr.v-data-table__selected.row-class:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #09263f !important;
}
</style>
